export default __webpack_public_path__ + "images/models/55fafbdebc993ea27c50da8ee278021c.usdz";